import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
} from "react-share";

import headerShapeRight from "../../assets/images/header-shape-right.svg";
import headerShapeLeft from "../../assets/images/header-shape-left.svg";
import { convertDateFormate, fixedHeader } from "../../values/utils";

import { Link, useParams } from "react-router-dom";
import BottomPanel from "./BottomPanel";
import LoginPopUp from "../popups/LoginPopUp";
import { useEffect, useState } from "react";

import Config from "../../values/Strings/Config"
import SubscriptionPopUp from "../popups/SubscriptionPopUp";
const ArticleType = ({ articleData, userData, saveArticle, type = "article" }) => {
    const pageURL = window.location.href;

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
    const [isArticleSaved, setIsArticleSaved] = useState(articleData?.data?.is_saved || false);


    const toggleLoginModal = () => {
        setIsLoginModalOpen(!isLoginModalOpen);
    };

    const toggleSubscriptionModal = () => {
        setIsSubscriptionModalOpen(!isSubscriptionModalOpen);
    };

    const articleSaveClickedEvent = () => {
        saveArticle(articleData?.data?.id);
        setIsArticleSaved(!isArticleSaved);
    }

    const [isAllowedToRead, setIsAllowedToRead] = useState(true);

    useEffect(() => {
        if (articleData?.data?.articleAccessType != "not_logged_in") {
            // Start a timer for 2 minutes (120000 ms)
            const timer = setTimeout(() => {
                // Get the current count from localStorage
                const countOfFreeArticleRead = parseInt(localStorage.getItem('countOfFreeArticleRead'), 10) || 0;

                // Increment the count and save it back to localStorage
                localStorage.setItem('countOfFreeArticleRead', countOfFreeArticleRead + 1);

                console.log(`Updated countOfFreeArticleRead: ${countOfFreeArticleRead + 1}`);
            }, 120000); //120000


            const count = parseInt(localStorage.getItem('countOfFreeArticleRead'), 10) || 0;
            console.log(`countOfFreeArticleRead: ${count}`);
            if (count > 5) {
                setIsSubscriptionModalOpen(true)
                setIsAllowedToRead(false);
            }
            // Cleanup the timer when the component unmounts or when dependencies change
            return () => clearTimeout(timer);
        }

    }, []);

    /*
    const insertLineBreak = (subtitle) => {
        if (!subtitle) return subtitle;

        const words = subtitle.split(" ");
        const totalLength = subtitle.length;
        const targetIndex = Math.floor(totalLength * 0.4); // Approximate 40% point

        let splitIndex = 0;
        let currentLength = 0;

        for (let i = 0; i < words.length; i++) {
            currentLength += words[i].length + 1; // Include space in length
            if (currentLength >= targetIndex) {
                splitIndex = i;
                break;
            }
        }

        return (
            <>
                {words.slice(0, splitIndex + 1).join(" ")}
                <br />
                {words.slice(splitIndex + 1).join(" ")}
            </>
        );
    };*/

    const insertLineBreak = (subtitle) => {
        if (!subtitle) return subtitle;
    
        //split based on the keyword <br> 
        //if <br> is present then replace it with line break 
        if (subtitle.includes("<br>")) {
            const parts = subtitle.split("<br>");
            return parts.map((part, index) => (
                <span key={index}>
                    {part}
                    {index < parts.length - 1 && <br />}
                </span>
            ));
        }
        
        const words = subtitle.split(" ");
        const wordCount = words.length;
    
        if (wordCount <= 10) {
            // Original 40% mid-split
            const targetIndex = Math.floor(subtitle.length * 0.4);
            let currentLength = 0;
            let splitIndex = 0;
    
            for (let i = 0; i < words.length; i++) {
                currentLength += words[i].length + 1;
                if (currentLength >= targetIndex) {
                    splitIndex = i;
                    break;
                }
            }
    
            return (
                <>
                    {words.slice(0, splitIndex + 1).join(" ")}<br />
                    {words.slice(splitIndex + 1).join(" ")}
                </>
            );
        }
    
        // If word count > 10, split by 1:2:3 ratio
        const ratioSum = 6;
        const firstSplit = Math.floor((wordCount * 1) / ratioSum);
        const secondSplit = Math.floor((wordCount * 3) / ratioSum);
    
        const part1 = words.slice(0, firstSplit).join(" ");
        const part2 = words.slice(firstSplit, secondSplit).join(" ");
        const part3 = words.slice(secondSplit).join(" ");
    
        return (
            <>
                {part1}<br />
                {part2}<br />
                {part3}
            </>
        );
    };
    
    


    return (
        <>
            <div className="content-container article-single-container">
                {/*<div className="article-post-single-thumbnail">
                    <img
                        className="d-none d-md-block"
                        src={articleData?.data?.image}
                        alt=""
                    />
                    <img
                        className="d-block d-md-none"
                        src={articleData?.data?.image}
                        alt=""
                    />
                    <h1>{articleData?.data?.title}</h1>
                </div>*/}
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="div d-flex flex-column-reverse flex-md-column">
                                <div className="news-post-content text-center">

                                    <h1>{articleData?.data?.title}</h1>
                                    <h4>{insertLineBreak(articleData?.data?.sub_title)}</h4>
                                    <div className="news-post-meta d-flex justify-content-between">
                                        <span className="news-post-cat">
                                            {articleData?.data?.category_name}{" "}
                                        </span>
                                        <span className="article-post-by">
                                            by <span>{articleData?.data?.author_detail?.name}{" "}</span>
                                        </span>

                                        <span className="news-post-date">
                                            {convertDateFormate(
                                                articleData?.data?.publish_date
                                            )}
                                        </span>
                                    </div>
                                    <div className="post-category-heading">
                                        <div className="pch-img">
                                            <img
                                                src={articleData?.data?.subject_image}
                                                alt=""
                                            />
                                        </div>
                                        <p>{articleData?.data?.subject_name}</p>
                                    </div>
                                </div>
                                {/*userData?.success === true && (
                                    <div className="news-post-save d-flex justify-content-center">

                                        <i
                                            className={`${isArticleSaved ? "fa" : "fa-regular"} fa-bookmark mt-1`}
                                            aria-hidden="true"
                                            type="button"
                                            onClick={() =>
                                                articleSaveClickedEvent()
                                            }
                                        ></i>
                                        <p
                                            type="button"
                                            onClick={() =>
                                                articleSaveClickedEvent()
                                            }
                                            style={{ marginLeft: 10 }}
                                        >
                                            {isArticleSaved ? "Saved" : "Save"}
                                        </p>
                                    </div>
                                )*/}
                                {
                                    type === "article" ? (
                                        articleData?.data?.image_credit ? (
                                            <div className="article-post-single-thumbnail">
                                                <figure>
                                                    <img
                                                        className="d-none d-md-block"
                                                        src={articleData?.data?.image}
                                                        alt=""
                                                    />
                                                    <img
                                                        className="d-block d-md-none"
                                                        src={articleData?.data?.image}
                                                        alt=""
                                                    />
                                                    <figcaption className="mb-0">
                                                        {articleData?.data?.image_credit}
                                                    </figcaption>
                                                </figure>
                                            </div>
                                        ) : (
                                            <div className="article-post-single-thumbnail">
                                                <img
                                                    className="d-none d-md-block"
                                                    src={articleData?.data?.image}
                                                    alt=""
                                                />
                                                <img
                                                    className="d-block d-md-none"
                                                    src={articleData?.data?.image}
                                                    alt=""
                                                />
                                            </div>
                                        )
                                    ) :
                                        (
                                            <></>
                                        )
                                }
                            </div>
                            {
                                console.log(articleData?.data)
                            }
                            {
                                articleData?.data?.articleAccessType === "free" || articleData?.data?.articleAccessType === "allowed" && isAllowedToRead && (
                                    <div className="post-single block-text">
                                        <div
                                            className="post-single block-text"
                                            dangerouslySetInnerHTML={{
                                                __html: articleData?.data?.description,
                                            }}
                                        />
                                    </div>
                                )
                            }
                            {articleData?.data?.articleAccessType === "paid" ? (
                                <>
                                    {
                                        isAllowedToRead && (
                                            <div className="post-single block-text">
                                                <div
                                                    className="post-single block-text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: articleData?.data?.description,
                                                    }}
                                                />
                                            </div>
                                        )
                                    }
                                    <div className="d-flex justify-content-center paywall">
                                        {" "}
                                        <p>Please</p>
                                        <Link
                                            to="/subscription"
                                            className="header-subscribe-btn d-md-block"
                                        >
                                            &nbsp;<u>Subscribe</u>&nbsp;
                                        </Link>
                                        <p>to read the full article</p>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        {" "}
                                        <p>or</p>
                                        <br />
                                    </div>
                                    <div>
                                        {/*Pay and read button */}
                                        <div className="">
                                            <div className="d-flex justify-content-center">
                                                <Link

                                                    to=""
                                                    className="btn btn-default"
                                                >
                                                    Read Full Article at just ₹50 <i className="fa fa-arrow-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <BottomPanel />
                                    {isLoginModalOpen && (
                                        <div className="popUp" id="popUp">
                                            <LoginPopUp closeModal={toggleLoginModal} />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div>
                                    {
                                        isAllowedToRead && (
                                            <div
                                                className="post-single block-text"
                                                dangerouslySetInnerHTML={{
                                                    __html: articleData?.data?.description,
                                                }}
                                            />
                                        )
                                    }
                                    {
                                        articleData?.data?.articleAccessType === "not_logged_in" && (
                                            <div className="d-flex justify-content-center paywall">
                                                {" "}
                                                <p>Please</p>
                                                <div
                                                    onClick={toggleLoginModal}
                                                >
                                                    <Link
                                                        to=""
                                                        className="header-login-btn d-md-block"
                                                    >
                                                        &nbsp;<u>Sign In</u>&nbsp;
                                                    </Link>
                                                </div>
                                                <p>to continue reading this article</p>
                                            </div>
                                        )
                                    }
                                </div>
                            )}
                            <ul className="share-post-list fixed d-none d-xl-flex flex-column">
                                <li>
                                    <FacebookShareButton
                                        url={pageURL}
                                        quote={articleData?.data?.sub_title}
                                        title={articleData?.data?.title}
                                    >
                                        <a href="" target="_blank">
                                            <i
                                                className="fab fa-facebook-f"
                                                aria-hidden="true"
                                            ></i>
                                        </a>
                                    </FacebookShareButton>
                                </li>
                                <li>
                                    <TwitterShareButton
                                        url={pageURL}
                                        quote={articleData?.data?.sub_title}
                                        title={articleData?.data?.title}
                                    >
                                        <a href="" target="_blank">
                                            <i
                                                className="fab fa-twitter"
                                                aria-hidden="true"
                                            ></i>
                                        </a>
                                    </TwitterShareButton>
                                </li>

                                <li>
                                    <LinkedinShareButton
                                        url={pageURL}
                                        quote={articleData?.data?.sub_title}
                                        title={articleData?.data?.title}
                                    >
                                        <a href="" target="_blank">
                                            <i
                                                className="fab fa-linkedin-in"
                                                aria-hidden="true"
                                            ></i>
                                        </a>
                                    </LinkedinShareButton>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {
                isLoginModalOpen && (
                    <div className="popUp" id="popUp">
                        <LoginPopUp closeModal={toggleLoginModal} source={"/article/" + articleData?.data?.slug} />
                    </div>
                )

            }

            {
                isSubscriptionModalOpen && (
                    <div className="popUp" id="popUp">
                        <SubscriptionPopUp closeModal={toggleSubscriptionModal} />
                    </div>
                )
            }
            {/* <!--============================== Content End ==============================--> */}
            {/* <!--============================== Content Start ==============================--> */}
            <div className="content-container pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="end-section">
                                <h5>
                                    <span className="left">
                                        <img loading="lazy" src={headerShapeRight} alt="" />
                                    </span>
                                    end
                                    <span className="right">
                                        <img loading="lazy" src={headerShapeLeft} alt="" />
                                    </span>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--============================== Content End ==============================--> */}
            {/* <!--============================== Content Start ==============================--> */}
            <div className="content-container pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="post-author-container d-flex flex-wrap">
                                <div className="post-author-content">
                                    <h5>Author</h5>
                                    <div className="post-auther">
                                        {
                                            articleData?.data?.author_detail?.meta_description &&
                                                (
                                                    articleData.data.author_detail.meta_description.includes("second") ||
                                                    articleData.data.author_detail.meta_description.includes("https:")
                                                ) ? (
                                                <Link
                                                    to={
                                                        "/author/" +
                                                        articleData?.data?.author_detail?.slug
                                                    }
                                                    className="post-auther-img"
                                                >
                                                    <img
                                                        src={
                                                            Config.AUTHOR_IMG_URL +
                                                            articleData?.data?.author_detail?.meta_description
                                                        }
                                                        alt=""
                                                    />
                                                </Link>
                                            ) : (
                                                <Link
                                                    to={
                                                        "/author/" +
                                                        articleData?.data?.author_detail?.slug
                                                    }
                                                    className="post-auther-img"
                                                >
                                                    <img
                                                        src={
                                                            Config.AUTHOR_IMG_URL +
                                                            "author-placeholder-vertical.png"
                                                        }
                                                        alt=""
                                                    />
                                                </Link>
                                            )
                                        }

                                        <div className="post-author-name">
                                            <Link
                                                to={
                                                    "/author/" +
                                                    articleData?.data?.author_detail?.slug
                                                }
                                                className="post-auther-img"
                                            >
                                                <h3>
                                                    {articleData?.data?.author_detail?.name}
                                                </h3>
                                            </Link>
                                            {
                                                articleData?.data?.author_detail?.designation !== null && (
                                                    <h6>
                                                        {
                                                            articleData?.data?.author_detail
                                                                ?.designation
                                                        }
                                                    </h6>
                                                )
                                            }
                                            <p>
                                                {articleData?.data?.author_detail?.about}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="share-post text-end">
                                    <h5>Share</h5>
                                    <ul className="share-post-list d-flex">
                                        <li>
                                            <FacebookShareButton
                                                url={pageURL}
                                                quote={articleData?.data?.sub_title}
                                                title={articleData?.data?.title}
                                            >
                                                <a href="#!" target="_blank">
                                                    <i
                                                        className="fab fa-facebook-f"
                                                        aria-hidden="true"
                                                    ></i>
                                                </a>
                                            </FacebookShareButton>
                                        </li>
                                        <li>
                                            <TwitterShareButton
                                                url={pageURL}
                                                quote={articleData?.data?.sub_title}
                                                title={articleData?.data?.title}
                                            >
                                                <a href="" target="_blank">
                                                    <i
                                                        className="fab fa-twitter"
                                                        aria-hidden="true"
                                                    ></i>
                                                </a>
                                            </TwitterShareButton>
                                        </li>
                                        <li>
                                            <LinkedinShareButton
                                                url={pageURL}
                                                quote={articleData?.data?.sub_title}
                                                title={articleData?.data?.title}
                                            >
                                                <a href="" target="_blank">
                                                    <i
                                                        className="fab fa-linkedin-in"
                                                        aria-hidden="true"
                                                    ></i>
                                                </a>
                                            </LinkedinShareButton>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ArticleType;